import { isNumber, pullAll } from 'lodash';
import { Framework } from '@/framework/instance';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { parseWsKey } from '../../utils';
import { Collaborators } from '../collaborators';

interface IRoom {
    onMessage: (type: OperateType, cb: (data: IEditMessage<any>) => void) => void;
    onTick: (cb: () => void) => number;
    isRealEdit: () => boolean;
    sendToAll: (type: OperateType, data?: unknown) => Promise<void>;
    collaborators: Collaborators;
}

export class SyncRenderIdsAdapter extends Framework {
    private operateInfoMap: Map<number, { time: number; wsKeys: Set<number> }> = new Map();

    constructor(
        identity: string,
        private room: IRoom,
    ) {
        super(identity);
        this.room.onTick(this.onTick.bind(this));
        room.onMessage(OperateType.SyncRenderIds, this.onReceiveRenderIds.bind(this));
    }

    /** 设置同步渲染 id 的画布 */
    set(wsKey: string | number, originIndex: number) {
        if (this.room.isRealEdit()) {
            const info = this.operateInfoMap.get(originIndex) || { time: Date.now(), wsKeys: new Set() };
            if (isNumber(wsKey)) {
                info.wsKeys.add(wsKey);
            } else {
                info.wsKeys.add(parseWsKey(wsKey).wsKey);
            }
            info.time = Date.now();
            this.operateInfoMap.set(originIndex, info);
        } else {
            this.operateInfoMap.delete(originIndex);
        }
        console.log('ot sync render ids set', originIndex, Array.from(this.operateInfoMap.keys()));
    }

    onTick() {
        const originIndexs = Array.from(this.operateInfoMap.keys());
        for (const originIndex of originIndexs) {
            const info = this.operateInfoMap.get(originIndex);
            if (info && Date.now() - info.time > 1500) {
                this.operateInfoMap.delete(originIndex);
                const wsKeys = Array.from(info.wsKeys).sort((a, b) => a - b);
                for (const wsKey of wsKeys) {
                    const member = this.room.collaborators.getMember(wsKey);
                    if (!member) continue;
                    if (this.room.collaborators.getWsKey() === wsKey) {
                        const originIds = this.framework.getRenderIdsWithoutExtraGroup(originIndex);
                        const extraGroupIdsSet = new Set(this.framework.pickRenderIdsExtraGroup(originIndex));
                        const delIds: string[] = [];
                        for (const id of originIds) {
                            const layer = this.framework.getLayer(id);
                            if (!layer || (layer.parentId && !extraGroupIdsSet.has(layer.parentId))) {
                                delIds.push(layer.id);
                            }
                        }
                        if (delIds.length) {
                            const currentOriginIds = this.framework.getRenderIds(originIndex);
                            pullAll(currentOriginIds, delIds);
                            this.framework.setRerender(originIndex);
                            this.framework.rerender();
                        }
                        pullAll(originIds, delIds);
                        this.room.sendToAll(OperateType.SyncRenderIds, [originIds, originIndex]);
                        console.log('ot SyncRenderIds', { originIndex, ids: this.framework.getRenderIds(originIndex) });
                    }
                }
            }
        }
        // console.log('ot sync render ids tick', Array.from(this.operateInfoMap.keys()));
    }

    private onReceiveRenderIds({ data }: IEditMessage<[string[], number]>) {
        const [originIds, originIndex] = data;
        this.operateInfoMap.delete(originIndex);
        const currentOriginIds = this.framework.getRenderIds(originIndex);
        const extraGroupIds = this.framework.pickRenderIdsExtraGroup(originIndex);
        currentOriginIds.length = 0;
        currentOriginIds.push(...originIds);
        currentOriginIds.push(...extraGroupIds);
        for (const id of currentOriginIds) {
            const layer = this.framework.getLayer(id, true);
            layer.parentId = undefined;
            this.framework.stage.addOrUpdate(layer, false, originIndex);
        }
        this.framework.setRerender(originIndex);
        this.framework.rerender();
        const activeInfo = this.framework.operate.getActiveInfo();
        if (activeInfo?.info.id && currentOriginIds.indexOf(activeInfo.info.id) === -1) {
            this.framework.operate.delActiveLayer();
        }
        console.log('ot onReceiveSyncRenderIds', { originIndex, ids: this.framework.getRenderIds(originIndex) });
    }
}
